"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M17.795 4.004h4.098c.305 0 .506.091.634.233.132.147.22.385.221.745.002 4.775.003 13.206 0 14.044-.001.362-.09.599-.22.744-.112.122-.28.207-.529.226l-.111.004-19.6-.001c-.372 0-.624-.102-.781-.251-.156-.148-.25-.37-.25-.677v-1.589c.002-2.692.004-7.143-.007-9.189-.003-.604.178-1.04.592-1.406.834-.74 1.652-1.502 2.467-2.262l.277-.258A1.27 1.27 0 0 1 5.5 4l12.295.004ZM5.648 5.7l-.072.068-.11.102c-.792.738-1.604 1.497-2.432 2.233l-.085.075.001.112c.011 2.055.01 6.51.008 9.2v.809H21.05v-.25c.001-2.327 0-8.08-.001-12.095v-.25h-3.253c-4.015 0-8.033 0-12.049-.004h-.099Z"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M14.853 14.303v-4.41h1.909l.661 2.217h.02l.66-2.217H20v4.41h-1.449v-2.735h-.019l-.825 2.735h-.832l-.819-2.735h-.018v2.735h-1.185Zm-.829-.057h-1.5v-4.41h1.5v4.41Zm-4.231 0c-.655 0-1.153-.145-1.486-.353v-.951h.592c.164.157.46.283.831.283.353 0 .555-.094.555-.296 0-.258-.24-.29-.706-.39-.806-.177-1.298-.48-1.298-1.418 0-.957.737-1.424 1.79-1.424.598 0 1.058.12 1.417.31v.931h-.592c-.158-.12-.454-.226-.775-.226-.36 0-.517.088-.517.277 0 .214.196.264.624.353 1.128.226 1.468.604 1.468 1.442 0 .914-.655 1.462-1.903 1.462ZM7.44 12.885H5.405c.056.416.264.53.655.53.372 0 .63-.095.806-.202h.448v.762c-.328.176-.744.328-1.475.328-1.247 0-1.839-.65-1.839-1.701 0-1.065.693-1.745 1.795-1.745 1.11 0 1.657.56 1.657 1.72 0 .157-.012.264-.012.308Zm-1.645-1.184c-.195 0-.352.094-.396.542h.768c-.019-.416-.139-.542-.372-.542Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};